var map = {
  "./uk.json": [
    "96175",
    "4852"
  ],
  "./bg.json": [
    "68232",
    "9553"
  ],
  "./el.json": [
    "21154",
    "4723"
  ],
  "./fi.json": [
    "7530",
    "5968"
  ],
  "./ja.json": [
    "66350",
    "2967"
  ],
  "./sv.json": [
    "62538",
    "6351"
  ],
  "./en-x-pseudo.json": [
    "10946",
    "2097"
  ],
  "./fr.json": [
    "83475",
    "744"
  ],
  "./th.json": [
    "19347",
    "548"
  ],
  "./fr-ca.json": [
    "72346",
    "2133"
  ],
  "./pl.json": [
    "62763",
    "8876"
  ],
  "./ro.json": [
    "60832",
    "6137"
  ],
  "./hu.json": [
    "95784",
    "8661"
  ],
  "./de.json": [
    "13108",
    "7409"
  ],
  "./vi.json": [
    "82490",
    "4979"
  ],
  "./en-001.json": [
    "62598",
    "3587"
  ],
  "./tr.json": [
    "97813",
    "809"
  ],
  "./da.json": [
    "38776",
    "7541"
  ],
  "./id.json": [
    "15198",
    "3327"
  ],
  "./zh-tw.json": [
    "62717",
    "6740"
  ],
  "./en-US.json": [
    "68767",
    "3190"
  ],
  "./no.json": [
    "39260",
    "4885"
  ],
  "./es.json": [
    "79527",
    "6524"
  ],
  "./ko.json": [
    "24197",
    "9574"
  ],
  "./cs.json": [
    "49361",
    "2706"
  ],
  "./sk.json": [
    "33177",
    "4138"
  ],
  "./nl.json": [
    "23689",
    "3990"
  ],
  "./pt-br.json": [
    "99946",
    "9313"
  ],
  "./pt.json": [
    "61283",
    "4884"
  ],
  "./ru.json": [
    "15578",
    "2027"
  ],
  "./zh-cn.json": [
    "28129",
    "1652"
  ],
  "./it.json": [
    "29838",
    "1615"
  ],
  "./hi.json": [
    "45852",
    "169"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 2220;
module.exports = __rspack_async_context;
